(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1425],{

/***/ 16205:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[publicDashboard]",
      function () {
        return __webpack_require__(15546);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://images-prod.forumm.to/3031/_next/static/media/header-background.10993a0a.png","height":480,"width":1924,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACBAMAAACXuoDeAAAAGFBMVEVq48Zn2NFjy9tgwOZYrOtJjeg8ceYwVuSCP/gQAAAAEklEQVR42mMoCzESYCgLMRIAAAvWAhnMYywNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LoadingBar = ()=>{
    const shimmerStyle = {
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-2 bg-blue-100 overflow-hidden relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-full absolute transform translate-x-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent",
            style: shimmerStyle
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBar);


/***/ }),

/***/ 69341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96963);
/* harmony import */ var _libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24499);
/* harmony import */ var _base_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51773);
/* harmony import */ var _components_landing_Media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11390);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52229);








const EventsView = (param)=>{
    let { events , types , title , currency , justify , skipSort =false  } = param;
    const { profile , isOrganizer , isAdmin , canEditEvent  } = (0,_libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)();
    const userId = profile === null || profile === void 0 ? void 0 : profile.userId;
    const [viewAll, setViewAll] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const isSpeaker = (event)=>{
        var ref;
        if (!event || !profile) return false;
        return !!((ref = event.speakers) === null || ref === void 0 ? void 0 : ref.find((f)=>{
            return f.email === (profile === null || profile === void 0 ? void 0 : profile.email);
        }));
    };
    const getAttendeeCount = (event)=>{
        var ref;
        if (!event || !event.eventId && !event.attendees) return 0;
        // if (event?.eventId === '31fffe01-557f-4c3c-a7f3-cb1ec9772277') return 374
        // if (event?.eventId === 'e9b5be85-1f71-409b-8b4b-67d3700853f6') return 253
        return event === null || event === void 0 ? void 0 : (ref = event.attendees) === null || ref === void 0 ? void 0 : ref.length;
    };
    // TODO: Define types correctly
    const renderEventCard = (e)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        if (!e) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        var ref13, ref14;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_landing_Media__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            eventId: e.eventId,
            url: (e === null || e === void 0 ? void 0 : (ref = e.event) === null || ref === void 0 ? void 0 : ref.eventType) === "FUNDRAISER" ? "/donation/".concat(e.event.donationUrl) : "/event/".concat(e.eventId),
            type: e.event.eventType,
            title: (ref1 = e.event) === null || ref1 === void 0 ? void 0 : ref1.title,
            description: (ref2 = e.event) === null || ref2 === void 0 ? void 0 : ref2.shortDescription,
            image: (ref13 = (ref3 = e.event) === null || ref3 === void 0 ? void 0 : ref3.bannerImage) !== null && ref13 !== void 0 ? ref13 : _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            banner: (ref14 = (ref4 = e.event) === null || ref4 === void 0 ? void 0 : ref4.thumbnailImage) !== null && ref14 !== void 0 ? ref14 : _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            organization: e === null || e === void 0 ? void 0 : (ref5 = e.event) === null || ref5 === void 0 ? void 0 : ref5.organizationName,
            startTime: (ref6 = e.event) === null || ref6 === void 0 ? void 0 : ref6.startDateTime,
            endTime: (ref7 = e.event) === null || ref7 === void 0 ? void 0 : ref7.endDateTime,
            timeZone: (ref8 = e.event) === null || ref8 === void 0 ? void 0 : ref8.timeZone,
            timeZoneId: (ref9 = e.event) === null || ref9 === void 0 ? void 0 : ref9.timeZoneId,
            canEdit: canEditEvent(e),
            isSpeaker: isSpeaker(e),
            isPublished: e.isPublished,
            attendees: getAttendeeCount(e),
            donors: (ref10 = e.fundraising) === null || ref10 === void 0 ? void 0 : ref10.donors,
            goal: (ref11 = e.fundraising) === null || ref11 === void 0 ? void 0 : ref11.goal,
            raised: (ref12 = e.fundraising) === null || ref12 === void 0 ? void 0 : ref12.raised,
            currency: currency !== null && currency !== void 0 ? currency : "GBP"
        }, e.eventId);
    };
    // TODO: Define types correctly
    const renderEvents = (data)=>{
        // TODO: Define types correctly
        return data.sort((a, b)=>skipSort ? 0 : (0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__/* .isEventAfter */ .r3)(a, b)).map((e)=>{
            var ref, ref1;
            if (((ref = e.event) === null || ref === void 0 ? void 0 : ref.eventType) == null) {
                return null;
            }
            if (!types.includes((ref1 = e.event) === null || ref1 === void 0 ? void 0 : ref1.eventType)) {
                return null;
            }
            if (title.length > 0 && !e.event.title.toLowerCase().includes(title.toLowerCase())) {
                return null;
            }
            return renderEventCard(e);
        });
    };
    const justifyClass = justify === "center" ? "" : " sm:justify-start sm:items-start";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
        className: "flex sm:-mx-4 md:w-[110%] max-w-[1530px] flex-wrap justify-center items-center ".concat(justifyClass),
        children: [
            viewAll ? renderEvents(events) : renderEvents(events === null || events === void 0 ? void 0 : events.slice(0, 8)),
            events.length <= 8 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : !viewAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "w-full justify-center flex mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                    className: "sm:min-w-[15rem] text-xs sm:text-sm",
                    title: "View All",
                    type: "primary",
                    textColor: "white",
                    onClick: ()=>setViewAll(true)
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventsView);


/***/ }),

/***/ 26052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MediaThumbnail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40654);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63696);
/* harmony import */ var _components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38999);





const MediaThumbnail = (param)=>{
    let { show =true , style ={} , media , key , size ="sm" , className ="" , alt , timeout =3000 , onClick =(e)=>{}  } = param;
    const [thumbnail, setThumbnail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const sizeClasses = {
        any: "",
        xs: "h-6 w-6",
        sm: "h-8 w-8",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (async ()=>{
            if (media) {
                setLoading(true);
                await (0,_libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__/* .getContentThumbnail */ .Lb)(media).then((data)=>{
                    setThumbnail(data);
                    setLoading(false);
                }).catch((err)=>{
                    console.error(err);
                    setLoading(false);
                });
            }
        })();
    }, [
        media
    ]);
    setTimeout(()=>setLoading(false), timeout);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (!thumbnail && loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    if (!thumbnail) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        style: style,
        onClick: (e)=>onClick(e),
        className: "".concat(sizeClasses[size], " ").concat(className, " object-cover"),
        alt: alt !== null && alt !== void 0 ? alt : "Media thumbnail",
        src: thumbnail,
        draggable: false
    }, key);
};


/***/ }),

/***/ 15546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ PublicDashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/event/EventsView.tsx
var EventsView = __webpack_require__(69341);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 10 modules
var Wrapper = __webpack_require__(41702);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/getPublicEventsByOrganisationUrl.ts

const GET_PUBLIC_EVENTS_BY_ORGANISATION_URL = (0,_generated/* graphql */.B)("\n  query GetPublicEventsByOrganisationUrlOverviews($url: String!) {\n    getPublicEventsByOrganisationUrl(url: $url) {\n      ...EventOverview\n    }\n  }\n");

// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./public/header-background.png
var header_background = __webpack_require__(79835);
// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./components/base/LoadingBar.tsx
var LoadingBar = __webpack_require__(623);
;// CONCATENATED MODULE: ./graphql/events/getPremiumEventsByOrganisationUrl.ts

const GET_PREMIUM_EVENTS_BY_ORGANISATION = (0,_generated/* graphql */.B)("\n  query GetPremiumEventsByOrganisationOverviews {\n    getPremiumEventsByOrganisation {\n      ...EventOverview\n    }\n  }\n");
const GET_PREMIUM_EVENTS_BY_ORGANISATION_URL = (0,_generated/* graphql */.B)("\n  query GetPremiumEventsByOrganisationUrlOverviews($url: String!) {\n    getPremiumEventsByOrganisationUrl(url: $url) {\n      ...EventOverview\n    }\n  }\n");
const GET_PREMIUM_EVENTS_FOR_USER_ID = (0,_generated/* graphql */.B)("\n  query GetPremiumEventsForUserId {\n    getPremiumEventsForUserId {\n      ...EventOverview\n    }\n  }\n");

// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./components/tootilp/Tooltip.tsx
var Tooltip = __webpack_require__(73912);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./pages/org/[publicDashboard].tsx



















var __N_SSP = true;
function PublicDashboard() {
    var ref;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const { getPermission  } = (0,useAuth/* useAuth */.aC)();
    const isDarkTheme = theme.type === "DARK";
    const router = (0,next_router.useRouter)();
    const { publicDashboard  } = router.query;
    const { loading , data  } = (0,useQuery/* useQuery */.a)(GET_PUBLIC_EVENTS_BY_ORGANISATION_URL, {
        variables: {
            url: publicDashboard
        },
        skip: !publicDashboard
    });
    const { loading: premiumLoading , data: premiumData  } = (0,useQuery/* useQuery */.a)(GET_PREMIUM_EVENTS_BY_ORGANISATION_URL, {
        variables: {
            url: publicDashboard
        },
        skip: !publicDashboard
    });
    const { loading: organisationLoading , profile: organisationData , ready: organisationReady  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)(publicDashboard);
    var ref1;
    const headerBanner = (ref1 = organisationData === null || organisationData === void 0 ? void 0 : organisationData.bannerImage) !== null && ref1 !== void 0 ? ref1 : header_background/* default.src */.Z.src;
    const headerTitle = (organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne) ? organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Welcome to your ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            organisationData === null || organisationData === void 0 ? void 0 : organisationData.name,
            " Space"
        ]
    });
    if (!organisationReady || organisationLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex-1 overflow-y-scroll mt-20 scrollbar-hide h-[calc(100vh_-_81px)] relative flex items-center flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {})
        });
    }
    const headerSubTitle = (organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo) ? organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Here you’ll discover all the events you’ve signed up to along with the events you’ve created."
    });
    const sortEvents = (events)=>{
        if (!events) return [];
        return [
            ...events
        ].sort((a, b)=>{
            var ref, ref1, ref2, ref3;
            const dateA = (a === null || a === void 0 ? void 0 : (ref = a.event) === null || ref === void 0 ? void 0 : ref.startDateTime) ? new Date(a === null || a === void 0 ? void 0 : (ref1 = a.event) === null || ref1 === void 0 ? void 0 : ref1.startDateTime) : null;
            const dateB = (b === null || b === void 0 ? void 0 : (ref2 = b.event) === null || ref2 === void 0 ? void 0 : ref2.startDateTime) ? new Date(b === null || b === void 0 ? void 0 : (ref3 = b.event) === null || ref3 === void 0 ? void 0 : ref3.startDateTime) : null;
            if (!dateA && !dateB) return 0 // Both dates are null or undefined
            ;
            if (!dateA) return 1 // dateA is null or undefined, so it should come after dateB
            ;
            if (!dateB) return -1 // dateB is null or undefined, so dateA should come before dateB
            ;
            return dateA.getTime() - dateB.getTime();
        });
    };
    const events = sortEvents(data === null || data === void 0 ? void 0 : data.getPublicEventsByOrganisationUrl).filter((f)=>{
        var ref;
        return moment_default()().isBefore(moment_default()((ref = f.event) === null || ref === void 0 ? void 0 : ref.endDateTime));
    });
    const premiumEvents = sortEvents(premiumData === null || premiumData === void 0 ? void 0 : premiumData.getPremiumEventsByOrganisationUrl).filter((f)=>{
        var ref;
        return moment_default()().isBefore(moment_default()((ref = f.event) === null || ref === void 0 ? void 0 : ref.endDateTime));
    });
    const isMember = (ref = getPermission("USER::MEMBERSHIP::*")) === null || ref === void 0 ? void 0 : ref.includes(organisationData === null || organisationData === void 0 ? void 0 : organisationData.name);
    var _currency, _currency1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex-1 overflow-y-scroll overflow-x-hidden scrollbar-hide h-[calc(100vh_-_81px)] relative flex items-center flex-col pb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "relative sm:flex justify-center w-full md:min-h-[25rem]",
                style: {
                    backgroundImage: "url(".concat(headerBanner, ")"),
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundColor: theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "lg:min-w-[57rem] z-999 relative w-full flex justify-center items-center ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "rounded-2xl shadow-lg md:w-[85%] max-w-[1500px] flex p-10 md:p-6 md:px-8 md:py-4 md:pt-6 md:pb-6 z-1000 animate-text-focus-in ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                        color: "backgroundColorBanner",
                        style: {
                            background: isDarkTheme ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(5px)",
                            WebkitBackdropFilter: "blur(5px)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "px-6 lg:px-0 z-1000 relative w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    className: "text-4xl pb-4 text-center leading-snug mt-2 px-12 sm:px-0 mb-2",
                                    children: headerTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "animate-text-focus-in",
                                    style: {
                                        animationDelay: "0.8s"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "text-base text-center px-12 sm:px-6 animate-text-focus-in",
                                        children: headerSubTitle
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "w-3/4 flex-col max-w-[1400px]",
                children: [
                    premiumEvents && premiumEvents.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex items-center mb-2 mt-8 pl-5 sm:pl-0 ml-[8%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: "text-2xl",
                                children: "Premium Events"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                className: "cursor-help",
                                tooltip: isMember ? "Already a member." : "Become a member today!",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaStar */.QJe, {
                                    className: "mx-2",
                                    fill: isMember ? "gold" : "gray"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Sign up",
                                type: "special",
                                show: !isMember,
                                onClick: ()=>router.push("/membership/".concat(organisationData.name))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "items-center flex flex-row",
                        children: !premiumLoading && premiumEvents && premiumEvents.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                            events: premiumEvents,
                            types: [
                                "ONLINE",
                                "IN_PERSON",
                                "FUNDRAISER"
                            ],
                            title: "",
                            currency: (_currency = organisationData.currency) !== null && _currency !== void 0 ? _currency : "GBP",
                            justify: "center"
                        })
                    }),
                    events && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        className: "text-2xl mb-2 mt-8 pl-5 sm:pl-0 ml-[8%]",
                        children: "Public Events"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "items-center flex flex-row",
                        children: [
                            !loading && events && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                                events: events,
                                types: [
                                    "ONLINE",
                                    "IN_PERSON",
                                    "FUNDRAISER"
                                ],
                                title: "",
                                currency: (_currency1 = organisationData.currency) !== null && _currency1 !== void 0 ? _currency1 : "GBP",
                                justify: "center"
                            }),
                            (premiumLoading || loading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex justify-center w-full py-32",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                                    size: "medium"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
PublicDashboard.Layout = Wrapper/* UnauthenticatedWrapperNoFooter */.Yz;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2987,9774,2888,179], function() { return __webpack_exec__(16205); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);